import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router";
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import { getConsent } from './utils/consent';
import CookieBanner from './components/CookieBanner';
import CookieSettingsModal from './components/CookieSettingsModal';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import Home from "./pages/Home";
import UnfallgutachtenPage from "./pages/UnfallgutachtenPage";
import UnfallgutachtenHamburgPage from "./pages/UnfallgutachtenHamburgPage";
import UnfallgutachtenNorderstedtPage from "./pages/UnfallgutachtenNorderstedtPage";
import UnfallgutachtenPinnebergPage from "./pages/UnfallgutachtenPinnebergPage";
import UnfallgutachtenAhrensburgPage from "./pages/UnfallgutachtenAhrensburgPage";
import UnfallgutachtenMainzPage from "./pages/UnfallgutachtenMainzPage";
import UnfallgutachtenFrankfurtPage from "./pages/UnfallgutachtenFrankfurtPage";
import UnfallgutachtenWiesbadenPage from "./pages/UnfallgutachtenWiesbadenPage";
import UnfallgutachtenRellingenPage from "./pages/UnfallgutachtenRellingenPage";
import RatgeberNachUnfallPage from "./pages/RatgeberNachUnfallPage";
import RatgeberWertminderungPage from "./pages/RatgeberWertminderungPage";
import RatgeberGutachtenKostenvoranschlagPage from "./pages/RatgeberGutachtenKostenvoranschlagPage";
import UeberUnsPage from "./pages/UeberUnsPage";
import GlossarPage from "./pages/GlossarPage";
import NachDemUnfallPage from "./pages/NachDemUnfallPage";
import BundesweitPage from "./pages/BundesweitPage";
import BewertungenPage from "./pages/BewertungenPage";
import KontaktPage from "./pages/KontaktPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import AGBPage from "./pages/AGBPage";
import PartnerbedingungenPage from "./pages/PartnerbedingungenPage";
import PartnerPage from "./pages/PartnerPage";
import PartnerAboPage from "./pages/PartnerAboPage";
import PartnerWillkommenPage from "./pages/PartnerWillkommenPage";
import PartnerRegistrierenPage from "./pages/PartnerRegistrierenPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import VerifyEmailHintPage from "./pages/VerifyEmailHintPage";
import UebersichtSubmitPage from "./pages/UebersichtSubmitPage";
import OnboardingPage from "./pages/OnboardingPage";
import DashboardPage from "./pages/DashboardPage";
import NeuerFallPage from "./pages/NeuerFallPage";
import BilderUploadPage from "./pages/BilderUploadPage";
import VideoUploadPage from "./pages/VideoUploadPage";
import MobileUploadPage from "./pages/MobileUploadPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminCaseDetailPage from "./pages/AdminCaseDetailPage";
import AdminAgreementsPage from "./pages/AdminAgreementsPage";
import PartnerProvisionenPage from "./pages/PartnerProvisionenPage";
import PartnerProfilPage from "./pages/PartnerProfilPage";
import PartnerNotificationSettingsPage from "./pages/PartnerNotificationSettingsPage";
import PartnerCaseDetailPage from "./pages/PartnerCaseDetailPage";
import PartnerCaseDetailNewPage from "./pages/PartnerCaseDetailNewPage";
import AdminPayoutsPage from "./pages/AdminPayoutsPage";
import PartnerLoginPage from "./pages/PartnerLoginPage";
import PartnerSetPasswordPage from "./pages/PartnerSetPasswordPage";
import KundenLoginPage from "./pages/KundenLoginPage";
import KundenSetPasswordPage from "./pages/KundenSetPasswordPage";
import KundenDashboardPage from "./pages/KundenDashboardPage";
import KundenForgotPasswordPage from "./pages/KundenForgotPasswordPage";
import AnwaltLoginPage from "./pages/AnwaltLoginPage";
import AnwaltSetPasswordPage from "./pages/AnwaltSetPasswordPage";
import AnwaltDashboardPage from "./pages/AnwaltDashboardPage";
import WebaktePage from "./pages/WebaktePage";
import NotFoundPage from "./pages/NotFoundPage";
import VertriebPraesentationPage from "./pages/VertriebPraesentationPage";
import VertriebDashboardPage from "./pages/VertriebDashboardPage";
import VertriebLoginPage from "./pages/VertriebLoginPage";
import VertriebSetPasswordPage from "./pages/VertriebSetPasswordPage";
import VertriebVisitenkartePage from "./pages/VertriebVisitenkartePage";
import VertriebContactsPage from "./pages/VertriebContactsPage";
import PublicVisitenkartePage from "./pages/PublicVisitenkartePage";
import AdminToursPage from "./pages/AdminToursPage";
import AdminSalespeoplePage from "./pages/AdminSalespeoplePage";
import AdminTrialManagementPage from "./pages/AdminTrialManagementPage";
import AdminPartnerSettingsPage from "./pages/AdminPartnerSettingsPage";
import AdminEmailTemplatesPage from "./pages/AdminEmailTemplatesPage";
import AdminAuditLogPage from "./pages/AdminAuditLogPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import AdminAnalyticsPage from "./pages/AdminAnalyticsPage";
import AdminReportsPage from "./pages/AdminReportsPage";
import AdminProfilePage from "./pages/AdminProfilePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VertriebNotificationSettingsPage from "./pages/VertriebNotificationSettingsPage";
import VertriebProfilePage from "./pages/VertriebProfilePage";
import VertriebPerformancePage from "./pages/VertriebPerformancePage";
import PartnerAgreementPage from "./pages/PartnerAgreementPage";
import AdminCRMPage from "./pages/AdminCRMPage";
import AdminAutoAssignPage from "./pages/AdminAutoAssignPage";
import AdminEmailImportPage from "./pages/AdminEmailImportPage";
import AdminChatsPage from "./pages/AdminChatsPage";
import AdminWhatsAppPage from "./pages/admin/AdminWhatsAppPage";

function App() {
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  useEffect(() => {
    // Check if consent decision exists
    const consent = getConsent();
    setShowCookieBanner(!consent);
    
    // Hide banner on payment/status pages
    const hideOnPaths = [
      '/partner/willkommen',
      '/payment-success',
      '/payment-cancel',
      '/portal/verify-email'
    ];
    const shouldHide = hideOnPaths.some(path => window.location.pathname.includes(path)) ||
                       window.location.search.includes('success=true') ||
                       window.location.search.includes('cancelled=true');
    
    if (shouldHide) {
      setShowCookieBanner(false);
    }
    
    // Listen for Footer link click
    const handleOpenSettings = () => {
      setShowCookieSettings(true);
    };
    
    window.addEventListener('openCookieSettings', handleOpenSettings);
    
    return () => {
      window.removeEventListener('openCookieSettings', handleOpenSettings);
    };
  }, []);

  const handleConsentGiven = () => {
    setShowCookieBanner(false);
  };

  const handleOpenSettings = () => {
    setShowCookieBanner(false);
    setShowCookieSettings(true);
  };

  const handleCloseSettings = () => {
    setShowCookieSettings(false);
  };

  return (
    <HelmetProvider>
      <ThemeProvider>
      <div className="App">
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/unfallgutachten" element={<UnfallgutachtenPage />} />
            <Route path="/unfallgutachten-hamburg" element={<UnfallgutachtenHamburgPage />} />
            <Route path="/unfallgutachten-norderstedt" element={<UnfallgutachtenNorderstedtPage />} />
            <Route path="/unfallgutachten-pinneberg" element={<UnfallgutachtenPinnebergPage />} />
            <Route path="/unfallgutachten-ahrensburg" element={<UnfallgutachtenAhrensburgPage />} />
            <Route path="/unfallgutachten-mainz" element={<UnfallgutachtenMainzPage />} />
            <Route path="/unfallgutachten-frankfurt" element={<UnfallgutachtenFrankfurtPage />} />
            <Route path="/unfallgutachten-wiesbaden" element={<UnfallgutachtenWiesbadenPage />} />
            <Route path="/unfallgutachten-rellingen" element={<UnfallgutachtenRellingenPage />} />
            <Route path="/ratgeber/nach-unfall-checkliste" element={<RatgeberNachUnfallPage />} />
            <Route path="/ratgeber/wertminderung" element={<RatgeberWertminderungPage />} />
            <Route path="/ratgeber/gutachten-oder-kostenvoranschlag" element={<RatgeberGutachtenKostenvoranschlagPage />} />
            <Route path="/ueber-uns" element={<UeberUnsPage />} />
            <Route path="/glossar" element={<GlossarPage />} />
            <Route path="/nach-dem-unfall" element={<NachDemUnfallPage />} />
            <Route path="/bundesweit" element={<BundesweitPage />} />
            <Route path="/bewertungen" element={<BewertungenPage />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/agb" element={<AGBPage />} />
            <Route path="/partnerbedingungen" element={<PartnerbedingungenPage />} />
            
            {/* Partner Public Pages */}
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/partner/abo" element={<PartnerAboPage />} />
            <Route path="/partner/willkommen" element={<PartnerWillkommenPage />} />
            <Route path="/partner/registrieren" element={<PartnerRegistrierenPage />} />
            <Route path="/partner/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/partner/payment-cancel" element={<PaymentCancelPage />} />
            <Route path="/partner/vereinbarung" element={<PartnerAgreementPage />} />
            
            {/* Portal Routes */}
            <Route path="/portal/login" element={<PartnerLoginPage />} />
            <Route path="/partner/set-password/:token" element={<PartnerSetPasswordPage />} />
            <Route path="/partner/passwort-setzen" element={<PartnerSetPasswordPage />} />
            <Route path="/portal/verify-email" element={<VerifyEmailPage />} />
            <Route path="/portal/verify-email-hint" element={<VerifyEmailHintPage />} />
            <Route path="/portal/onboarding" element={<OnboardingPage />} />
            <Route path="/portal/dashboard" element={<DashboardPage />} />
            <Route path="/portal/neuer-fall" element={<NeuerFallPage />} />
            <Route path="/portal/bilder-upload" element={<BilderUploadPage />} />
            <Route path="/portal/video-upload" element={<VideoUploadPage />} />
            <Route path="/portal/mobile-upload/:caseId" element={<MobileUploadPage />} />
            <Route path="/portal/uebersicht-submit" element={<UebersichtSubmitPage />} />
            <Route path="/portal/provisionen" element={<PartnerProvisionenPage />} />
            <Route path="/portal/profil" element={<PartnerProfilPage />} />
            <Route path="/portal/benachrichtigungen" element={<PartnerNotificationSettingsPage />} />
            <Route path="/portal/faelle/:caseId" element={<PartnerCaseDetailPage />} />
            <Route path="/portal/akte/:caseId" element={<PartnerCaseDetailNewPage />} />
            
            {/* Customer Portal */}
            <Route path="/kunden/login" element={<KundenLoginPage />} />
            <Route path="/kunden/set-password" element={<KundenSetPasswordPage />} />
            <Route path="/kunden/dashboard" element={<KundenDashboardPage />} />
            <Route path="/kunden/passwort-vergessen" element={<KundenForgotPasswordPage />} />
            <Route path="/kunden/reset-password" element={<KundenForgotPasswordPage />} />
            
            {/* Lawyer Portal */}
            <Route path="/anwalt/login" element={<AnwaltLoginPage />} />
            <Route path="/anwalt/set-password" element={<AnwaltSetPasswordPage />} />
            <Route path="/anwalt/dashboard" element={<AnwaltDashboardPage />} />
            
            {/* Webakte (shared) */}
            <Route path="/akte/:caseId" element={<WebaktePage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/cases/:caseId" element={<AdminCaseDetailPage />} />
            <Route path="/admin/payouts" element={<AdminPayoutsPage />} />
            <Route path="/admin/touren" element={<AdminToursPage />} />
            <Route path="/admin/vertriebsteam" element={<AdminSalespeoplePage />} />
            <Route path="/admin/trial-management" element={<AdminTrialManagementPage />} />
            <Route path="/admin/partner-einstellungen" element={<AdminPartnerSettingsPage />} />
            <Route path="/admin/email-templates" element={<AdminEmailTemplatesPage />} />
            <Route path="/admin/audit-log" element={<AdminAuditLogPage />} />
            <Route path="/admin/einstellungen" element={<AdminSettingsPage />} />
            <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
            <Route path="/admin/reports" element={<AdminReportsPage />} />
            <Route path="/admin/profile" element={<AdminProfilePage />} />
            <Route path="/admin/vereinbarungen" element={<AdminAgreementsPage />} />
            <Route path="/admin/crm" element={<AdminCRMPage />} />
            <Route path="/admin/auto-assign" element={<AdminAutoAssignPage />} />
            <Route path="/admin/email-import" element={<AdminEmailImportPage />} />
            <Route path="/admin/chats" element={<AdminChatsPage />} />
            <Route path="/admin/whatsapp" element={<AdminWhatsAppPage />} />
            
            {/* Vertrieb */}
            <Route path="/vertrieb/login" element={<VertriebLoginPage />} />
            <Route path="/vertrieb/passwort-setzen" element={<VertriebSetPasswordPage />} />
            <Route path="/vertrieb/praesentation" element={<VertriebPraesentationPage />} />
            <Route path="/vertrieb/dashboard" element={<VertriebDashboardPage />} />
            <Route path="/vertrieb/visitenkarte" element={<VertriebVisitenkartePage />} />
            <Route path="/vertrieb/benachrichtigungen" element={<VertriebNotificationSettingsPage />} />
            <Route path="/vertrieb/profil" element={<VertriebProfilePage />} />
            <Route path="/vertrieb/performance" element={<VertriebPerformancePage />} />
            <Route path="/vertrieb/kontakte" element={<VertriebContactsPage />} />
            <Route path="/vertrieb/passwort-reset" element={<ResetPasswordPage />} />
            
            {/* Public Business Card */}
            <Route path="/visitenkarte/:salespersonId" element={<PublicVisitenkartePage />} />
            
            {/* Password Reset - All user types */}
            <Route path="/partner/passwort-vergessen" element={<ForgotPasswordPage />} />
            <Route path="/portal/passwort-vergessen" element={<ForgotPasswordPage />} />
            <Route path="/partner/passwort-reset" element={<ResetPasswordPage />} />
            <Route path="/portal/passwort-reset" element={<ResetPasswordPage />} />
            <Route path="/passwort-reset" element={<ResetPasswordPage />} />
            
            {/* 404 Catch-All */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>

        {/* DSGVO Cookie Consent */}
        {showCookieBanner && (
          <CookieBanner
            onAccept={handleConsentGiven}
            onOpenSettings={handleOpenSettings}
          />
        )}
        
        <CookieSettingsModal
          isOpen={showCookieSettings}
          onClose={handleCloseSettings}
        />
        
        {/* PWA Install Prompt */}
        <PWAInstallPrompt />
      </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;